import {createReducer} from "@reduxjs/toolkit";
import {updateRanges, updateOneOrientation} from "../actions/ContinuousAttributeActions";
import defaultColors from '../../helpers/DefaultColors';

export const continuousAttributeReducer = createReducer(
    {
        filters: defaultColors
    },
    (builder) => {
        builder
            .addCase(updateRanges, (state, action) => {
                state['filters'] = action.payload;
            })
            .addCase(updateOneOrientation, (state, {payload}) => {
                state['filters'][payload.orientation] = payload.data;
            });
    }
);
